import { Button, Card, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { FormInput } from '../../Components/FormInputs';
import { LockOutlined } from '@ant-design/icons';
import { APIwithoutInterceptor } from "../../Axios/Axios";


import {
    getResetPassword, getAuthenticationConfig,
    getValidationMessages, getPasswordExists
} from "../../Helpers/APIEndpoints/Endpoints";



const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const type = location.state?.type;
    const username = location.state?.username;

    // This is for getting the user Context
    const getUserContext = () => {
        const uaData = (navigator as Navigator & { userAgentData?: any }).userAgentData;
        return {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: uaData?.platform ?? 'unknown',
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(""), 3000);
            return () => clearTimeout(timer); // Cleanup to prevent memory leaks
        }
    }, [error]);

    const handleError = (messageText: string) => {
        setError(messageText);
        message.error(messageText);
    };



   

    const validateInputData = async (password: string, username: string) => {
        try {
            const [authConfig, validationMessages, passwordCheck] = await Promise.all([
                APIwithoutInterceptor.post(getAuthenticationConfig),
                APIwithoutInterceptor.post(getValidationMessages),
                APIwithoutInterceptor.post(getPasswordExists, { loginId: username, password })
            ]);

            const parsedData = JSON.parse(authConfig.data.data);
            const passwordPolicy = parsedData.security.passwordPolicy;
            const messageresponse = validationMessages.data;
            const isPasswordMatched = passwordCheck.data.data.isPasswordMatched;

            if (isPasswordMatched) return messageresponse.resetPasswordPolicyViolation;

            return checkPasswordPolicy(password, passwordPolicy, messageresponse);
        } catch (error) {
            console.error("Error validating password:", error);
            return "An unexpected error occurred while validating your password. Please try again later.";
        }
    };

    const checkPasswordPolicy = (
        password: string,
        policy: any,
        messages: any
    ): string | null => {
        if (!password) return null;

        if (!isLengthValid(password, policy)) return messages.passwordPolicyViolation;
        if (policy.requireUppercase && !/[A-Z]/.test(password)) return messages.passwordPolicyViolation;
        if (policy.requireLowercase && !/[a-z]/.test(password)) return messages.passwordPolicyViolation;
        if (policy.requireDigit && !/\d/.test(password)) return messages.passwordPolicyViolation;
        if (policy.requireSpecialCharacter && !hasAllowedSpecialChar(password, policy.allowedSpecialCharacters))
            return messages.passwordPolicyViolation;

        return null;
    };

    const isLengthValid = (password: string, policy: any): boolean =>
        password.length >= policy.minLength && password.length <= policy.maxLength;

    const hasAllowedSpecialChar = (password: string, allowedChars: string): boolean => {
        const escapedChars = allowedChars.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        return new RegExp(`[${escapedChars}]`).test(password);
    };



    useEffect(() => {
        if (!username) {
            message.error('You cannot directly access this page. Please enter your username first.');
            navigate('/login', { state: { type: type } });
        }
    }, [username]);

    const validatePassword = async () => {
        if (password !== confirmPassword) {
            handleError('Passwords do not match');
            return;
        }
        const error = await validateInputData(confirmPassword, username);
        if (error) {
            handleError(error);
            return;
        } else {
            setError(""); // Clears the error when input is correct
        }
        const userContext = getUserContext();

        try {
            const response = await APIwithoutInterceptor.post(getResetPassword, {
                loginId: username ?? '',
                password: confirmPassword ?? '',
                ...userContext,
            });
            const data = await response.data;
            if (data.message == "OK") {  
                message.success('Password changed sucessfully.');
                setError('');
                navigate('/login', { state: { type: type } });
            }

        }
        catch (error) {
            console.error("Error validating password:", error);
            handleError("Error validating password. Please try again.");
        }


    }

    return (
        <div className="login-container">
            <Card className="login-card">
                <h1 className="login-title">Reset Password</h1>
                <div className="form-group text-center mt-3">
                    <FormInput
                        name='password'
                        label='Password'
                        placeholder='Password'
                        inputType="password"
                        value={password}
                        onChange={(e: any) => setPassword(e.target.value)}
                        prefix={<LockOutlined />}
                        widthSize="large"
                        rules={[
                            { required: true, message: "Password is required" },
                        ]}>
                    </FormInput>
                </div>
                <div className="form-group text-center mt-3">
                    <FormInput
                        name='Confirm Password'
                        label='Confirm Password'
                        placeholder='Confirm Password'
                        inputType="password"
                        value={confirmPassword}
                        onChange={(e: any) => setConfirmPassword(e.target.value)}
                        prefix={<LockOutlined />}
                        widthSize="large"
                        rules={[
                            { required: true, message: "Confirm Password is required" }
                        ]}>
                    </FormInput>
                </div>
                {error && <div className="login-error"><span style={{ color: "red" }}>{error}</span></div>}
                <Button type="primary" className="login-button" onClick={validatePassword}>
                    Submit
                </Button>
            </Card>
        </div>
    );
}
export default ResetPassword;